import { customAlphabet } from 'nanoid'
import { firebaseConfig, user } from './firebase'

export class Utils {
  static nanoid = customAlphabet('1234567890abcdefghijklmnopqrstuvwxyz', 6)

  static file = {
    linkToToken: link => {
      return new URLSearchParams(link).get('token')
    },
    tokenToLink: (path, token) => {
      return [
        'https://firebasestorage.googleapis.com/v0/b/',
        firebaseConfig.storageBucket,
        '/o/',
        encodeURIComponent(path),
        '?alt=media&token=',
        token
      ].join('')
    }
  }
}
